import {DomainGraphType} from 'app-core/framework/CoreObjectConstants';
import {getApiBaseForObjectType} from 'app-core/framework/CoreObjectIntrospectionUtils';
import {postJSONPromise} from 'util/Net';

const API_BASE = getApiBaseForObjectType(DomainGraphType.PLATE_DESIGN_TEMPLATE);

export interface CreatePlateDesignTemplateParams {
  scratchPlateId: string;
  templateCollectionId: string;
  name: string;
}

export interface CreatePlateDesignTemplateResponse {
  id: string;
}

const PlateDesignTemplateDAO = {
  createPlateDesignTemplate(
    params: CreatePlateDesignTemplateParams
  ): Promise<CreatePlateDesignTemplateResponse> {
    return postJSONPromise({
      url: API_BASE,
      data: {
        scratchPlateId: params.scratchPlateId,
        templateCollectionId: params.templateCollectionId,
        name: params.name,
      },
    });
  },
};

export default PlateDesignTemplateDAO;
